import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignSentHandoff } from '@/pages/workspaces/automations/[campaignId]/sent/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/sent/',
)({
  component: JourneysCampaignSentHandoff,
});
